var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicineChest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M558.4 511.9v-31.2c0-4.7-3.8-8.5-8.5-8.5h-56.4c-4.7 0-8.5 3.8-8.5 8.5v27.9c0 12.9-10.5 23.4-23.4 23.4h-26.9c-4.7 0-8.5 3.8-8.5 8.5v56.4c0 4.7 3.8 8.5 8.5 8.5h16.1c5.5 0 14.2 4.5 14.2 10l1 41.7c0 10.3 3.1 18.6 13.4 18.6h13.1c4.2 0 8.1 1.4 11.2-.6.4-.2.8-.4 1.2-.4h41.7c6.4 0 11.7-5.2 11.7-11.7v-35.6c0-12.2 9.8-22 22-22H617c4.7 0 8.5-3.8 8.5-8.5v-66.8c0-8.9-7.2-16.1-16.1-16.1h-48.8c-1.2.1-2.2-.9-2.2-2.1z",
    fill: "#6ee7b7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M855.4 289.3c15.1 0 29.4 6 40.2 16.8s16.8 25.1 16.8 40.2V750c0 15.1-6 29.4-16.8 40.2-10.7 10.8-25 16.8-40.2 16.8H170c-15.1 0-29.4-6-40.2-16.8S113 765.1 113 750V346.3c0-15.1 6-29.4 16.8-40.2 10.8-10.8 25.1-16.8 40.2-16.8h685.4m0-15H170c-39.6 0-72 32.4-72 72V750c0 39.6 32.4 72 72 72h685.4c39.6 0 72-32.4 72-72V346.3c0-39.6-32.4-72-72-72z",
    fill: "##\\\\\\\\064e3b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M630.7 213.3v98.8h-236v-98.8h236m3-15h-242c-6.6 0-12 5.4-12 12v104.8c0 6.6 5.4 12 12 12h242c6.6 0 12-5.4 12-12V210.3c0-6.6-5.4-12-12-12zm-358.4 61V274h-61.7v-14.7h61.7m3-15h-67.7c-6.6 0-12 5.4-12 12V277c0 6.6 5.4 12 12 12h67.7c6.6 0 12-5.4 12-12v-20.7c0-6.6-5.4-12-12-12zm533.5 15V274h-61.7v-14.7h61.7m3-15h-67.7c-6.6 0-12 5.4-12 12V277c0 6.6 5.4 12 12 12h67.7c6.6 0 12-5.4 12-12v-20.7c0-6.6-5.4-12-12-12zM513.3 409.4c40.8 0 79.1 15.9 108 44.7 28.8 28.8 44.7 67.2 44.7 108s-15.9 79.1-44.7 108c-28.8 28.8-67.2 44.7-108 44.7s-79.1-15.9-108-44.7c-28.8-28.8-44.7-67.2-44.7-108s15.9-79.1 44.7-108c28.9-28.8 67.2-44.7 108-44.7m0-15c-92.6 0-167.7 75.1-167.7 167.7s75.1 167.7 167.7 167.7S681 654.7 681 562.1s-75.1-167.7-167.7-167.7z",
    fill: "##\\\\\\\\064e3b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M198.6 289h91.7v518h-91.7zm536.6 0h91.7v518h-91.7z",
    fill: "#6ee7b7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicineChest);
export default __webpack_public_path__ + "static/media/Medicine-Chest.2fe7ddb9de172ce7e3608e9f5b7d433e.svg";
export { ForwardRef as ReactComponent };